import React from "react";
import StonesStore from '../../stores/stonesStore';

export default (props) => {
  let fgm = StonesStore.getFeatureGroupMeta(props.groupName.trim());
  let groupName = props.groupName;
  let img = props.groupImg;
  if(fgm) {
    if(fgm.customDisplayName && fgm.customDisplayName.length > 0) {
      groupName = fgm.customDisplayName;
    }
    if(fgm.customImageUrl && fgm.customImageUrl.length > 0) {
      img = `/content/Views/quickquote-v3/images/pj-scope-icons/${!props.disabled ? 'enabled' : 'disabled'}/${fgm.customImageUrl}`;
    }
  }
  return (
    <div className={"project-scope-line-item " + (props.disabled ? "project-scope-line-item--disabled" : "")}>
      <div className="project-scope-line-item-image" onClick={() =>{props.setStep(props.datastep)}}>
        <div className={"project-scope-line-item-image-img project-scope-line-item-image-img--"
             +props.groupName.trim().toLowerCase().replace(" ","-")}
             style={img && {backgroundImage: `url(${img})`}} />
      </div>
      <div className="project-scope-line-item-name">{groupName}</div>
      {!props.disabled ? props.content : null}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/projectScope/projectScopeItem.js